import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function useWikiLocation() {
  const { pageId } = useParams<{ pageId?: string }>();
  const navigate = useNavigate();
  const openPage = useCallback((nextPageId: string | null) => {
    navigate(nextPageId ? `/wiki/${nextPageId}` : "/wiki");
  }, [navigate]);
  return { pageId: pageId ?? null, openPage };
}

